import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAuctions, getSingleAuction } from "../../../api";
import ConvertToArabicNumbers from "../../../utils/convert_numbers";
import AuctionDetailsModal from "./details_modal";
import SupervisorModal from "./supervisor";
import Biddnigs from "./live_bidding";
import LoadingCircle from "./loading";
import { useAuth } from "../../../store/authProvider";
import Client from "../../../utils/client";

const SingleAuction = () => {
  let { id } = useParams();
  const [auction, setAuction] = useState(null);
  const [detailsModal, setDetailsModal] = useState(false);
  const [showsupervisor, setShowSupervisor] = useState(false);
  const [showBiddings, setShowBiddings] = useState(false);
  const currentUser = localStorage.getItem("user_id");
  const isAuth = useAuth();
  const navigator = useNavigate();
  const ref = useRef(null);
  const {
    data: auctions,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["auctions"],
    queryFn: () => getSingleAuction(id),
    onSuccess: (data) => setAuction(data),
    initialData: [],
  });



  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  if (!auction || isLoading) {
    return (
      <div className="w-screen relative h-screen ">
        <div className="absolute top-1/2 left-1/2">
          <LoadingCircle />
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="w-11/12 mt-5 lg:w-screen lg:px-36">
        <div className="flex flex-col lg:flex-row justify-between items-center">
          <div className=" w-full lg:w-64 mb-4 flex justify-center bg-center bg-no-repeat bg-flipped-logo ">
            <img
              src={auction._sub_category.image}
              alt=""
              width={100}
              height={50}
              className=" w-auto object-cover h-36 "
            />
          </div>
          <p className="font-bold text-lg lg:text-[34px]">
            {auction._sub_category.name} - {auction._state.name}
          </p>
        </div>
        <div className="h-5" />
        <div className="flex flex-col ">
          <p className="text-right font-bold text-lg mb-6">الصور و الفديوهات</p>
          <div
            dir="rtl"
            className="flex flex-row-reverse justify-between mx-auto items-center lg:w-[90%]  "
          >
            <button
              onClick={() => scroll(-400)}
              className={`my-auto  ${
                auction.images?.length <= 2 && auction.video?.length < 1
                  ? "hidden lg:hidden"
                  : "hidden lg:block"
              }`}
            >
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M31.75 35.5L24.25 28L31.75 20.5"
                  stroke="#23AA49"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect
                  x="1.25"
                  y="-1.25"
                  width="52.5"
                  height="52.5"
                  rx="26.25"
                  transform="matrix(-1 0 0 1 55.5 3)"
                  stroke="#23AA49"
                  strokeWidth="2.5"
                />
              </svg>
            </button>

            <div
              ref={ref}
              dir="rtl"
              className={`flex gap-3 lg:w-[80%] no-scrollbar  scroll-smooth overflow-x-scroll snap-x lg:snap-none `}
            >
              <div className="flex gap-2 scroll-ms-4 snap-start  ">
                {auction.images.map((e, index) => (
                  <img
                    key={index}
                    className={` object-cover  rounded-md  ${
                      auction.images?.length <= 1 && auction.video?.length === 0
                        ? "h-72 w-[40rem]"
                        : "h-32 w-48  lg:w-[22rem] lg:h-52 "
                    }`}
                    src={e}
                    alt=""
                  />
                ))}

                {auction.video?.map((e, index) => (
                  <video
                    key={index}
                    className={` object-cover  scroll-ms-4   rounded-md ${
                      auction.images?.length === 0 && auction.video?.length <= 1
                        ? "h-72 w-[40rem]"
                        : "h-32 w-48  lg:w-[22rem] lg:h-52"
                    }`}
                    controls
                  >
                    <source src={e} type="video/mp4" />
                  </video>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="h-5" />

        <div className="flex flex-col ">
          <p className="text-right font-bold text-lg mb-6">تفاصيل المحصول</p>
        </div>
        <div className="h-5" />

        <div className="flex flex-col border bg-white border-gray-300 rounded-lg lg:w-[65rem] mx-auto px-8 ">
          {/* <div className="">
            <p>{auction.description}</p>
          </div> */}

          <div className="h-5" />
          <div className="flex flex-col items-end gap-2">
            <div className="flex flex-row-reverse gap-3 items-center font-bold text-lg">
              <svg
                width="69"
                height="68"
                className="w-10"
                viewBox="0 0 69 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse
                  cx="34.1969"
                  cy="33.9094"
                  rx="33.9098"
                  ry="33.9094"
                  fill="#23AA49"
                />
                <path
                  d="M34.1968 35.8491C36.534 35.8491 38.4287 33.9544 38.4287 31.6172C38.4287 29.28 36.534 27.3853 34.1968 27.3853C31.8595 27.3853 29.9648 29.28 29.9648 31.6172C29.9648 33.9544 31.8595 35.8491 34.1968 35.8491Z"
                  stroke="white"
                  strokeWidth="2.03458"
                />
                <path
                  d="M22.8307 29.1486C25.5028 17.4024 42.9052 17.4159 45.5638 29.1622C47.1236 36.0526 42.8374 41.8851 39.0802 45.4931C36.3539 48.1245 32.0406 48.1245 29.3007 45.4931C25.5571 41.8851 21.2709 36.0391 22.8307 29.1486Z"
                  stroke="white"
                  strokeWidth="2.03458"
                />
              </svg>
              <p>الموقع</p>
              <p>:</p>
              <p>{auction._state.name}</p>
            </div>
            <div className="flex flex-row-reverse gap-4 items-center font-bold text-lg">
              <svg
                width="69"
                height="69"
                className="w-10"
                viewBox="0 0 69 69"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse
                  cx="34.1969"
                  cy="34.6028"
                  rx="33.9098"
                  ry="33.9094"
                  fill="#23AA49"
                />
                <path
                  d="M22.2202 28.8896L34.1971 35.8208L46.0926 28.9303"
                  stroke="white"
                  strokeWidth="2.03458"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M34.1973 48.11V35.8076"
                  stroke="white"
                  strokeWidth="2.03458"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M31.3897 22.1623L24.1466 26.1908C22.5054 27.0996 21.1626 29.3783 21.1626 31.2501V38.9137C21.1626 40.7855 22.5054 43.0642 24.1466 43.973L31.3897 48.0015C32.936 48.856 35.4724 48.856 37.0187 48.0015L44.2618 43.973C45.9031 43.0642 47.2459 40.7855 47.2459 38.9137V31.2501C47.2459 29.3783 45.9031 27.0996 44.2618 26.1908L37.0187 22.1623C35.4589 21.2942 32.936 21.2942 31.3897 22.1623Z"
                  stroke="white"
                  strokeWidth="2.03458"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M40.9795 36.7572V31.7929L28.1074 24.3599"
                  stroke="white"
                  strokeWidth="2.03458"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p>الكمية</p>
              <p>:</p>
              <p className="flex flex-row">
                {ConvertToArabicNumbers(auction.quantity)} {auction._unit.name}
              </p>
            </div>

            <div className="flex flex-row-reverse gap-3 pt-1 font-bold text-lg">
              <div>
                <svg
                  width="69"
                  height="69"
                  className="w-10 h-fit"
                  viewBox="0 0 69 69"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="32.5" cy="32.5" r="32.5" fill="#23AA49" />
                  <path
                    d="M34.3351 43.8146L32.5043 44.9962C30.8033 46.0479 28.4401 44.8664 28.4401 42.7629V35.8161C28.4401 34.8942 27.9207 33.7127 27.3884 33.0634L22.4023 27.8177C21.7401 27.1555 21.2207 25.9869 21.2207 25.1948V22.1824C21.2207 20.6113 22.4023 19.4297 23.8436 19.4297H41.1649C42.6062 19.4297 43.7878 20.6113 43.7878 22.0525V24.9351C43.7878 25.9869 43.1256 27.2983 42.4764 27.9475"
                    stroke="white"
                    strokeWidth="1.94768"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M39.1004 32.2587L34.5038 36.8552C34.322 37.037 34.1533 37.3746 34.1143 37.6213L33.8676 39.3742C33.7767 40.0104 34.2182 40.4519 34.8544 40.361L36.6073 40.1143C36.854 40.0754 37.2046 39.9066 37.3734 39.7248L41.9699 35.1283C42.762 34.3362 43.1385 33.4143 41.9699 32.2457C40.8143 31.0901 39.8925 31.4666 39.1004 32.2587Z"
                    stroke="white"
                    strokeWidth="1.94768"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M38.4512 32.9082C38.8407 34.3105 39.9314 35.4012 41.3337 35.7907"
                    stroke="white"
                    strokeWidth="1.94768"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <p className="">الوصف</p>
              <p>:</p>
              <p dir="rtl" className="lg:w-[85%]">
                {auction.description}
              </p>
            </div>
          </div>
          <div className="h-5" />
        </div>

        <div className="w-full flex justify-center mt-10 hover:cursor-pointer items-center">
          <div
            className={`w-full lg:w-[400px] h-[47px] bg-primary rounded-2xl flex justify-center items-center text-white font-bold ${
              detailsModal || showBiddings || showsupervisor ? "hidden" : ""
            }`}
            onClick={() => {
              if (isAuth.isAuth) {
                if (auction.owner === currentUser) {
                  setShowBiddings(true);
                } else {
                  setDetailsModal(true);
                }
              } else {
                navigator("/signin");
              }
            }}
          >
            {isAuth.isAuth && auction.owner === currentUser
              ? "عرض المزايدات الجارية"
              : "دخول المزاد"}
          </div>
        </div>
        <div>
          {detailsModal && (
            <AuctionDetailsModal
              setShowDetails={setDetailsModal}
              setShowSupervisor={setShowSupervisor}
              setShowBiddings={setShowBiddings}
              auction={auction}
            />
          )}
          {showBiddings && (
            <Biddnigs setShowBiddings={setShowBiddings} auction={auction} />
          )}
          {showsupervisor && (
            <SupervisorModal
              setShowSupervisor={setShowSupervisor}
              auction={auction}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default SingleAuction;
